import { render, staticRenderFns } from "./HighDeptPickerConfig.vue?vue&type=template&id=2f5e1c34&scoped=true"
import script from "./HighDeptPickerConfig.vue?vue&type=script&lang=js"
export * from "./HighDeptPickerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5e1c34",
  null
  
)

export default component.exports